import geometry from './geometry'

/* eslint-disable no-param-reassign */


const drawHelpers = {
  resetTransform(context) {
    context.setTransform(1, 0, 0, 1, 0, 0)
  },
  transformContext(context, globalCoords, rotation, localCoords) {
    localCoords = localCoords || { w: 100, h: 100 }
    context.translate(globalCoords.x, globalCoords.y)
    this.rotateContext(context, rotation)
    context.scale(globalCoords.w / localCoords.w, globalCoords.h / localCoords.h)
  },
  rotateContext(context, rotation, reverse) {
    if (rotation) {
      if (rotation.anchor) {
        context.translate(rotation.anchor.x, rotation.anchor.y)
      }
      const angle = reverse ? geometry.degToRad(rotation.angle) : -geometry.degToRad(rotation.angle)
      context.rotate(angle)
      if (rotation.anchor) {
        context.translate(-rotation.anchor.x, -rotation.anchor.y)
      }
    }
  },
  rotateLayer(context, localRotation, reverse) {
    const rotation = { anchor: { x: 50, y: 50 }, ...localRotation }
    this.rotateContext(context, rotation, reverse)
  },
  drawLayer(context, layer, api) {
    if (layer.rotation) {
      this.rotateLayer(context, layer.rotation)
    }
    this.drawTextureOrTile(context, layer.coords, layer.texture, api)
    if (layer.rotation) {
      this.rotateLayer(context, layer.rotation, true)
    }
  },
  redrawBackground(context, globalCoords, api) {
    const {
      x, y, w, h
    } = globalCoords
    if (api.panel.background) {
      context.drawImage(api.resources.imagesById[api.panel.background], x, y, w, h, x, y, w, h)
    } else {
      context.clearRect(x, y, w, h)
    }
  },
  drawTexture(context, localCoords, textureId, api) {
    const image = api.resources.imagesById[textureId]
    const {
      x, y, w, h
    } = localCoords
    context.drawImage(image, x, y, w, h)
  },
  drawTile(context, localCoords, tile, api) {
    const tileset = api.resources.tilesets[tile.tileset]
    const { frame } = tileset.item(tile)
    const {
      x, y, w, h
    } = localCoords
    context.drawImage(tileset.image, frame.x, frame.y, frame.w, frame.h, x, y, w, h)
  },
  drawTextureOrTile(context, localCoords, textureOrTile, api) {
    if (Number.isInteger(textureOrTile)) {
      return this.drawTexture(context, localCoords, textureOrTile, api)
    }
    return this.drawTile(context, localCoords, textureOrTile, api)
  },
  setGif(element, item, context, api, loops) {
    if (!item.gif) {
      const layer = element.layers[0]
      const gifData = api.resources.gifsById[layer.texture]
      const gif = new api.Gif(gifData, context, (ctx, frame) => {
        item.displayFunctionValues.buffer = frame.buffer
        api.action.redrawItem(item)
      })
      gif.loopCount = loops || 0
      item.gif = gif
    } else {
      item.gif.reset()
    }
    api.action.redrawItem(item)
  }
}

export default drawHelpers
